var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51991 4.93407L0.392908 1.80807L1.80791 0.393066L21.6069 20.1931L20.1919 21.6071L16.8819 18.2971C15.1231 19.4126 13.0826 20.0034 10.9999 20.0001C5.60791 20.0001 1.12191 16.1201 0.180908 11.0001C0.610938 8.67078 1.78254 6.54296 3.52091 4.93407H3.51991ZM13.7569 15.1721L12.2929 13.7081C11.733 13.976 11.1037 14.0636 10.4918 13.9589C9.88 13.8541 9.31571 13.5621 8.87678 13.1232C8.43785 12.6843 8.14588 12.12 8.04112 11.5081C7.93637 10.8963 8.02399 10.267 8.29191 9.70707L6.82791 8.24307C6.19162 9.20456 5.90718 10.3564 6.02274 11.5036C6.1383 12.6507 6.64676 13.7227 7.46203 14.5379C8.27729 15.3532 9.34926 15.8617 10.4964 15.9772C11.6436 16.0928 12.7954 15.8084 13.7569 15.1721ZM6.97391 2.76007C8.22091 2.27007 9.57991 2.00007 10.9999 2.00007C16.3919 2.00007 20.8779 5.88007 21.8189 11.0001C21.5125 12.6658 20.8238 14.2376 19.8069 15.5921L15.9469 11.7321C16.0616 10.9597 15.9937 10.1712 15.7488 9.42972C15.5039 8.68827 15.0888 8.01448 14.5366 7.46233C13.9845 6.91019 13.3107 6.49504 12.5693 6.25014C11.8278 6.00524 11.0393 5.93741 10.2669 6.05207L6.97391 2.76107V2.76007Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eyeHide.5326761f49a960d9e48c452a34f4e1d6.svg";
export { ForwardRef as ReactComponent };